/* eslint-disable no-console */
import {useGlobal, setGlobal, addCallback, removeCallback} from "reactn"

const GlobalState = (props) => {
  const {children, initLang} = props
  const globalLang = initLang

  // get existing state
  const [langState] = useGlobal("lang")

  const initialState = {
    showNewsletterOverlay: true,
    lang: globalLang || "de",
    postOverviewItemsVisible: 50
  }

  // initialize
  if(!langState || langState && globalLang !== langState) setGlobal({...initialState})

  const alertState = global => {
    console.log("New global state:")
    console.log(global)
  }

  addCallback(alertState)
  removeCallback(alertState)

  return children
}

export default GlobalState
